<template>
  <v-card class="ma-5" min-height="390" height="390" max-width="350">
    <v-img
      class="white--text align-end"
      gradient="to bottom,rgba(72, 75, 90, 0.33),rgba(115, 119, 145, 0.33)"
      height="200px"
      :src="(image != '' && image != undefined) ? image : 'https://personal-website-assets.s3.amazonaws.com/Blogs/placeholder-img.jpeg'"
    />
    <div class="d-flex flex-column" style="height:190px">
      <p
        class="text-left mb-0 pa-4"
        style="font-weight:600;white-space: normal;font-size:20px"
      >{{ title }}</p>
      <p class="text--primary text-left px-4 pb-2 mb-0">{{ date }}</p>
      <div class="d-flex align-end justify-space-between full-height" style="height:100%">
        <v-chip
          class="ml-4 mb-4"
          :color="attribute == 'Cloud' ? 'pink' : null || attribute == 'Professional' ? 'green' : null || attribute == 'Productivity' ? 'blue' : null"
          label
          text-color="white"
        >
          <v-icon left>mdi-label</v-icon>
          {{ attribute }}
        </v-chip>
        <v-card-actions>
          <a id="link" target="_blank" :href="url">
            <v-btn color="#2c3e50" text>Read More</v-btn>
          </a>
        </v-card-actions>
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    id: String,
    image: String,
    title: String,
    date: String,
    url: String,
    attribute: String
  }
};
</script>

<style>
@import "../../assets/css/test.css";
@import "../../assets/css/responsive.css";

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  height: 100%;
  width: 100%;
  opacity: 0;
  transition: 0.5s ease;
  background: rgba(88, 88, 90, 0.8);
}
.wrapper:hover .overlay {
  opacity: 1;
}
.blog-img {
  cursor: pointer;
}
</style>